module.exports = __webpack_public_path__ + "img/01.a4208601.png";